module.exports = __webpack_public_path__ + "static/Sauradyuti-Coondu-e7970e0f6fb8d1599acf59091b323f62.jpg";